
import React, { useState } from 'react'
import { FaGraduationCap } from "react-icons/fa6";
import { FaXmark, FaPlus } from "react-icons/fa6";
import { Link } from 'react-router-dom';



const MobileNav = ({handleHideState, show}) => {
    
  return (
    <section className={show === true ? "bg-[#5146AE] w-full h-[100vh] flex flex-col justify-between p-4 py-7" : "hidden"}>
    <section className='w-full'>
    <section className='flex justify-between mb-12'>
    <div className='flex my-auto'>
                <Link to="/"><span className='bg-[#E57853] w-[30px] h-[30px] flex justify-center items-center rounded-lg'>
                <FaGraduationCap color='white' />
                </span></Link>
                <Link to="/">
                <span className='text-[white] ml-2 font-medium text-2xl logo'>Quest-Inspire</span>
                </Link>
            </div>
            <div className='my-auto' onClick={handleHideState}>
                <FaXmark color='white' className='w-[24px] h-[24px] my-auto' />
            </div>
    </section>
    <ul>
        <li className='flex mb-8'>
            <Link to="/" className='flex'>
            <FaPlus className='w-[24px] h-[24px]' color='white' /> <span className='text-white text-base ml-2  my-auto'>Home</span>
            </Link>
        </li>
        <li className='flex mb-8'>
            <Link to="/about" className='flex'>
            <FaPlus className='w-[24px] h-[24px]' color='white' /> <span className='text-white text-base ml-2  my-auto'>About Us</span>
            </Link>
        </li>
        <li className='flex mb-8'>
            <Link to="/services" className='flex'>
            <FaPlus className='w-[24px] h-[24px]' color='white' /> <span className='text-white text-base ml-2  my-auto'>Our Services</span>
            </Link>
        </li>
        <li className='flex mb-8'>
            <Link to="/contact" className='flex'>
            <FaPlus className='w-[24px] h-[24px]' color='white' /> <span className='text-white text-base ml-2  my-auto'>Contact Us</span>
            </Link>
        </li>
        <li className='flex mb-8'>
            <Link to="/admissions" className='flex'>
            <FaPlus className='w-[24px] h-[24px]' color='white' /> <span className='text-white text-base ml-2  my-auto'>Admission</span>
            </Link>
        </li>
    </ul>
    </section>
    <section className='w-full'>
    <button className='bg-[#fff] rounded-[3px] text-[#5146AE] w-full h-[56px] font-semibold text-base'>Student</button>
                <button style={{border: '1px solid white'}} className='mr-4 text-[#fff] text-base font-normal w-full h-[56px] rounded-[3px] mt-7 logo'>Admin</button>
               
            </section>
    </section>
  )
}

export default MobileNav
